import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ChevronDown } from 'lucide-react';

const Homepage = () => {
  const featuredProjects = [
    {
      id: 'res-1',
      name: 'The Courtyard Residence',
      location: 'Vadodara',
      tagline: 'A family home designed around light, air, and three generations',
      image: 'https://images.pexels.com/photos/12594566/pexels-photo-12594566.jpeg'
    },
    {
      id: 'com-1',
      name: 'Elevate Office',
      location: 'Ahmedabad',
      tagline: 'A headquarters that reflects ambition',
      image: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72'
    },
    {
      id: 'res-2',
      name: 'River View Villa',
      location: 'Surat',
      tagline: 'Commanding views meet grounded living',
      image: 'https://images.unsplash.com/photo-1724688078741-6d89e587e809'
    },
     {
      id: 'res-1',
      name: 'The Courtyard Residence',
      location: 'Vadodara',
      tagline: 'A family home designed around light, air, and three generations',
      image: 'https://images.pexels.com/photos/12594566/pexels-photo-12594566.jpeg'
    }
  ];

  const scrollToContent = () => {
    window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
  };

  return (
    <div className="bg-[#f5f2ed]">
      {/* Hero Section */}
      <section className="relative h-screen w-full">
        <div className="absolute inset-0 image-overlay">
          <img
            src="https://raw.githubusercontent.com/partnershipnidhi-prog/Hale-Modular/refs/heads/Hale-Branch/frontend/public/smart-living-rooms-furniture-ideas-gurgaon%20(3).jpg?token=GHSAT0AAAAAADZUQ3ZULDDDXOV7NXO5GNBM2OSENPA"
            alt="Hale Modular Architecture"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-['Playfair_Display'] text-white mb-4 fade-in">
            Hale Modular
          </h1>
          <p className="text-xl md:text-2xl text-white/90 tracking-widest uppercase mb-12 fade-in" style={{ animationDelay: '0.2s' }}>
            Built to Last
          </p>
          <Link
            to="/contact"
            className="bg-[#f5f2ed] text-[#1a1a1a] px-10 py-4 text-base tracking-wide hover:bg-white transition-all duration-300 hover:-translate-y-1 fade-in"
            style={{ animationDelay: '0.4s' }}
          >
            Start a Conversation
          </Link>
        </div>
        <button
          onClick={scrollToContent}
          className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/80 hover:text-white transition-colors animate-bounce"
          aria-label="Scroll down"
        >
          <ChevronDown size={32} />
        </button>
      </section>

      {/* Philosophy Statement */}
      <section className="section-padding text-center max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-5xl font-['Playfair_Display'] text-[#1a1a1a] leading-relaxed mb-6 fade-in">
          We don't just build structures.
          <br />
          We engineer spaces that stand the test of time.
        </h2>
      </section>

      {/* Selected Work */}
      <section className="section-padding bg-white">
        <div className="max-w-[1600px] mx-auto">
          <h2 className="text-4xl md:text-5xl font-['Playfair_Display'] text-[#1a1a1a] mb-4">
            Selected Work
          </h2>
          <p className="text-[#9c9590] mb-16 max-w-2xl">
            A curated selection of projects that define our commitment to precision and permanence.
          </p>

          <div className="space-y-24">
            {featuredProjects.map((project, index) => (
              <div key={project.id} className="group fade-in" style={{ animationDelay: `${index * 0.2}s` }}>
                <Link to="/work" className="block">
                  <div className="relative h-[60vh] overflow-hidden mb-6 hover-scale">
                    <img
                      src={project.image}
                      alt={project.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex flex-col md:flex-row md:items-baseline md:justify-between">
                    <div className="mb-4 md:mb-0">
                      <h3 className="text-2xl md:text-3xl font-['Playfair_Display'] text-[#1a1a1a] mb-2">
                        {project.name} — {project.location}
                      </h3>
                      <p className="text-[#9c9590]">{project.tagline}</p>
                    </div>
                    <ArrowRight className="text-[#b8986e] group-hover:translate-x-2 transition-transform" size={24} />
                  </div>
                </Link>
              </div>
            ))}
          </div>

          <div className="text-center mt-16">
            <Link
              to="/work"
              className="inline-block border border-[#1a1a1a] text-[#1a1a1a] px-10 py-4 text-base tracking-wide hover:bg-[#1a1a1a] hover:text-[#f5f2ed] transition-all duration-300"
            >
              View All Projects
            </Link>
          </div>
        </div>
      </section>

      {/* How We Work Teaser */}
      <section className="section-padding">
        <div className="max-w-[1600px] mx-auto text-center">
          <p className="text-xl md:text-2xl text-[#1a1a1a] mb-6">
            A seamless journey from first conversation to final walkthrough
          </p>
          <Link
            to="/process"
            className="inline-flex items-center gap-2 text-[#b8986e] hover:gap-4 transition-all duration-300"
          >
            <span className="text-lg">Discover Our Process</span>
            <ArrowRight size={20} />
          </Link>
        </div>
      </section>

      {/* Architects Callout */}
      <section className="section-padding bg-[#1a1a1a] text-[#f5f2ed]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-['Playfair_Display'] mb-6">
            For Architects
          </h2>
          <p className="text-lg md:text-xl text-[#9c9590] leading-relaxed mb-8">
            We partner with architects who share our obsession with precision.
            If you're an architect looking for a build partner who respects your vision, let's talk.
          </p>
          <Link
            to="/contact"
            className="inline-block bg-[#f5f2ed] text-[#1a1a1a] px-10 py-4 text-base tracking-wide hover:bg-white transition-all duration-300"
          >
            Connect With Us
          </Link>
        </div>
      </section>

      {/* Trust Strip */}
      <section className="py-12 bg-white">
        <div className="max-w-[1600px] mx-auto px-6 text-center">
          <p className="text-[#9c9590] text-sm tracking-wide">
            Trusted by leading architects and 30+ families across Gujarat & Mumbai
          </p>
        </div>
      </section>

      {/* Closing CTA */}
      <section className="section-padding text-center">
        <h2 className="text-3xl md:text-5xl font-['Playfair_Display'] text-[#1a1a1a] mb-8">
          Every great space begins with a conversation.
        </h2>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link
            to="/contact"
            className="bg-[#1a1a1a] text-[#f5f2ed] px-10 py-4 text-base tracking-wide hover:bg-[#2a2a2a] transition-all duration-300"
          >
            Book a Consultation
          </Link>
          <a
            href="https://wa.me/919876543210"
            target="_blank"
            rel="noopener noreferrer"
            className="border border-[#1a1a1a] text-[#1a1a1a] px-10 py-4 text-base tracking-wide hover:bg-[#1a1a1a] hover:text-[#f5f2ed] transition-all duration-300 flex items-center gap-2"
          >
            <span>WhatsApp Us</span>
          </a>
        </div>
      </section>
    </div>
  );
};

export default Homepage;
